import axios from 'axios'
import qs from "qs";

axios.interceptors.request.use(
    (config) => {
        if (!config.__noloading) {
            // showLoading(); // Uncomment if using a loading indicator
        }
        const tokenKey = process.env.VUE_APP_LOCAL_TOKEN_KEY;
        config.headers["Authorization"] = localStorage.getItem(tokenKey);

        if (!/^https?:\/\//i.test(config.url)) {
            config.baseURL = process.env.VUE_APP_API_BASE_URL;
        }

        const exceptUris = [];

        if (config.method.toLowerCase() === "post") {
            const contentType = config.headers["Content-Type"]?.toLowerCase();

            if (contentType === "application/json;charset=utf-8" || contentType === "multipart/form-data") {
                return config;
            }

            if (exceptUris.some(uri => config.url.includes(uri))) {
                config.headers["Content-Type"] = "application/json;charset=UTF-8";
                return config;
            }

            if (config.data) {
                config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
                config.data = qs.stringify(config.data);
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);


axios.interceptors.response.use(
    (response) => {
        const api = response.request.responseURL;

        if (api !== `${process.env.VUE_APP_API_BASE_URL}/auth/tokenInfo` && response.data.error === -2) {
            window.location.href = "/login";
        }

        if (!response.config.__noloading) {
            // hideLoading();
        }

        return response;
    },
    (error) => {
        const res = {
            data: {
                error: -1,
                message: error.message,
            },
        };

        if (error.config && !error.config.__noloading) {
            // hideLoading();
        }
        return Promise.reject(res);
    }
);


axios.postjson = (uri, params = {}, config = {}) => {
    const finalConfig = {
        ...config,
        headers: {
            "Content-Type": "application/json;charset=utf-8",
            ...config.headers
        }
    };
    return axios.post(uri, params, finalConfig);
};

axios.getToken = function () {
    return localStorage.getItem(process.env.VUE_APP_LOCAL_TOKEN_KEY);
};

axios.setToken = function (token) {
    localStorage.setItem(process.env.VUE_APP_LOCAL_TOKEN_KEY, token);
};


export default axios